import { render } from "./EditExif.vue?vue&type=template&id=1f9b9cf0&scoped=true&ts=true"
import script from "./EditExif.vue?vue&type=script&lang=ts"
export * from "./EditExif.vue?vue&type=script&lang=ts"

import "./EditExif.vue?vue&type=style&index=0&id=1f9b9cf0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9b9cf0"]])

export default __exports__